interface LocalFileEndCountdownProps {
  msUntil: number | null;
  verb: string;
  hint?: string;
  overrideText?: string;
}

export function LocalFileEndCountdown({ msUntil, verb, hint, overrideText }: LocalFileEndCountdownProps) {
  if (msUntil === null && !overrideText) return null;

  const seconds = msUntil === null ? 0 : Math.ceil(msUntil / 1000);
  const message = overrideText ?? (seconds <= 0 ? `${verb} now` : `${verb} in ${seconds} s`);

  return (
    <div
      role="status"
      aria-live="assertive"
      data-testid="local-file-end-countdown"
      className="flex flex-col items-center gap-1 px-4 py-3 rounded-lg bg-red-50 dark:bg-red-900/20 border-2 border-red-300 dark:border-red-700 text-center"
    >
      <span className="text-3xl font-bold tabular-nums text-red-700 dark:text-red-300">{message}</span>
      {hint && !overrideText && <span className="text-sm text-red-700/80 dark:text-red-300/80">{hint}</span>}
    </div>
  );
}
